import { styled } from 'styled-components'

import Tooltip from 'core/components/lib/Tooltip'
import { useCompanyInfo } from 'core/stores'
import variables from 'core/styles/variables'

const Wrapper = styled.span`
  color: ${variables.colorBlack70};
`

const Inner = styled.span`
  display: inline-flex;
  align-items: center;
  white-space: pre-wrap;
`

const Content = styled.div`
  text-align: left;
  color: ${variables.colorBlack70};
  font-size: 16px;
`

const PoweredByPeach = () => {
  const { brandName } = useCompanyInfo()

  return (
    <Wrapper>
      {'Powered by '}
      <Inner>
        {'Peach '}
        <Tooltip
          content={
            <Content>{`${brandName ? `${brandName} is using` : 'Using'} Peach technology to provide customers with online tools to manage their loans.`}</Content>
          }
          iconSize='20px'
          style={{ display: 'inline-block' }}
          width={400}
        />
      </Inner>
    </Wrapper>
  )
}

export default PoweredByPeach
